import React from "react";
import { BRAND_SECONDARY_RGB } from "~/brandColors";

type Props = React.SVGProps<SVGSVGElement> & {
  color?: string;
};

const LockIcon: React.FC<Props> = ({
  className,
  color = BRAND_SECONDARY_RGB,
  ...props
}) => (
  <svg
    className={className}
    width="16"
    height="20"
    viewBox="0 0 16 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3 20C2.45 20 1.979 19.804 1.587 19.412C1.195 19.02 0.999333 18.5493 1 18V8C1 7.45 1.196 6.979 1.588 6.587C1.98 6.195 2.45067 5.99933 3 6H4V4C4 2.9 4.39167 1.95833 5.175 1.175C5.95833 0.391667 6.9 0 8 0C9.1 0 10.0417 0.391667 10.825 1.175C11.6083 1.95833 12 2.9 12 4V6H13C13.55 6 14.021 6.196 14.413 6.588C14.805 6.98 15.0007 7.45067 15 8V18C15 18.55 14.804 19.021 14.412 19.413C14.02 19.805 13.5493 20.0007 13 20H3ZM3 18H13V8H3V18ZM8 15C8.55 15 9.021 14.804 9.413 14.412C9.805 14.02 10.0007 13.5493 10 13C10 12.45 9.804 11.979 9.412 11.587C9.02 11.195 8.54933 10.9993 8 11C7.45 11 6.979 11.196 6.587 11.588C6.195 11.98 5.99933 12.4507 6 13C6 13.55 6.196 14.021 6.588 14.413C6.98 14.805 7.45067 15.0007 8 15ZM6 6H10V4C10 3.45 9.804 2.979 9.412 2.587C9.02 2.195 8.54933 1.99933 8 2C7.45 2 6.979 2.196 6.587 2.588C6.195 2.98 5.99933 3.45067 6 4V6Z"
      fill={color}
    />
  </svg>
);

export default LockIcon;
